import { z } from '@harvestiq/zod';
import {
  CampaignCoverageTier,
  RmaLrpCommodityCodes,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { zCalendarDate, zDecimalRequired, zIsoDate } from '@harvestiq/zod';

export const downloadLrpQuoteRequestSchema = z.object({
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  typeCode: z.nativeEnum(RmaLrpTypeCodes),
  numberOfHead: z.coerce.number(),
  marketingMonths: z.array(z.coerce.number()),
  targetSalesEffectiveDate: zCalendarDate().optional(),
  endDate: zIsoDate().optional(),
  targetWeight: zDecimalRequired(),
  coverageTier: z.nativeEnum(CampaignCoverageTier),
});

export type DownloadLrpQuoteRequest = z.input<
  typeof downloadLrpQuoteRequestSchema
>;
